import CourseAndDegreeCertificate from "../../../../src/pages/use-cases/page-content/content-publishing/course-and-degree-certificate.md";
import * as React from 'react';
export default {
  CourseAndDegreeCertificate,
  React
};